import React from 'react'
import { Controller, FieldPath, FieldValues } from 'react-hook-form';
import styled from 'styled-components';
import ImageUploader from '../PlusWebsiteEditor/components/ImageUploader/ImageUploader';
import { StyledQuestionFieldContainer } from '../Questionnaires/QuestionnairePage/components/QuestionViewerEditor/QuestionEditor/styles';
import { StyledImageHolder } from '../PlusWebsiteEditor/components/ImageUploader/ImageUploader.styles';
import { ErrorMessage } from '../Services/styled-components';
import { InputProps } from './types';

interface ImageEditorProps<TFieldValues extends FieldValues, TName extends FieldPath<TFieldValues>>
  extends InputProps<TFieldValues, TName> {
  width: string;
  height: string;
  label?: string;
  suggestedSize?: string;
}

function ImageEditor<TFieldValues extends FieldValues, TName extends FieldPath<TFieldValues>>({
  control,
  name,
  height,
  width,
  label = 'Image',
  suggestedSize,
}: ImageEditorProps<TFieldValues, TName>) {
  return (
    <Controller
      control={control}
      name={name}
      render={({ field, fieldState }) => (
        <StyledQuestionFieldContainer>
          <StyledImageUploader
            width={width}
            height={height}
            title={`${label} (${suggestedSize})`}
            onChange={field.onChange}
            url={field.value ?? null}
          />
          <ErrorMessage>{fieldState.error?.message}</ErrorMessage>
        </StyledQuestionFieldContainer>
      )}
    />
  );
}

const StyledImageUploader = styled(ImageUploader)<{
  width: string;
  height: string;
}>`
  width: ${props => props.width};

  ${StyledImageHolder} {
    height: ${props => props.height};
  }
`;

export default ImageEditor;
